let BASE_URL = process.env.REACT_APP_BASE_URL;

if(process.env.NODE_ENV==="development") {
    BASE_URL = process.env.REACT_APP_DEV_URL
} 

export const REMEDY_LIST_URL = `${BASE_URL}/api/remedy/list`; //GET
export const REMEDY_ADD_URL = `${BASE_URL}/api/remedy/add`; //POST

export const remedyUrl = (id) => `${BASE_URL}/api/remedy/${id}`; //GET
export const remedyEditUrl = (id) => `${BASE_URL}/api/remedy/edit/${id}`; //POST

export const LOCATION_LIST_URL = `${BASE_URL}/api/location/list`; //GET
export const locationResourceListUrl = (loc) =>  `${BASE_URL}/api/location/${loc}/list`; //GET
export const locationResourceAddtUrl = (loc) =>  `${BASE_URL}/api/location/${loc}/add`; //POST
export const locationResourceEditUrl = (loc,id) =>  `${BASE_URL}/api/location/${loc}/edit/${id}`; //POST

export const KEY_RESOURCE_LIST_URL = `${BASE_URL}/api/key-resources/list`; //GET
export const KEY_RESOURCE_ADD_URL = `${BASE_URL}/api/key-resources/add`; //POST
export const keyResourceEditUrl = (id) =>  `${BASE_URL}/api/key-resources/edit/${id}`; //POST

export const FEEDBACK_URL = `${BASE_URL}/api/feedback/add`; //POST
 
export const TRACK_LIST_URL = `${BASE_URL}/api/live-tracking/bed/list`; //GET

export const VOLUNTEER_GSHEET_URL = `https://spreadsheets.google.com/feeds/list/1Cxl5djzZ8FwrM3Z-hPWq1_E_kbGxSuWl41zqkK2SKGo/1/public/values?alt=json`; //GET

export const STORY_LIST_GSHEET_URL ='https://spreadsheets.google.com/feeds/list/1PJYEE61hvn5fsf7lWFaZlxCzj63k8_0UtZSrHN3h-P8/1/public/values?alt=json'